export const pt_BR = {
  links: {
    home: "Página Inicial",
    mission: "Missão",
    services: "Serviços",
    contact: "Contato",
    privacy: "Política de Privacidade",
  },
  contact: {
    title: "Contato",
    findUs: "Ache-nos",
    btnWhatsapp: "btn_whatsapp_ptBR.png",
    Call: "Ligue 754.752.1888",
    SMS: "MSG 754.752.1888",
    WhatsappMsg: "WhatsApp 754.276.1746",
    AfterHours:
      "ATENÇÃO: FORA DO HORÁRIO DE ATENDIMENTO E NOS FINAIS DE SEMANA - Estamos disponíveis somente por mensagem de texto em:",
  },
  img: {
    img1: "1_ptBR2.jpg",
    img2: "2_ptBR2.jpg",
  },
  footer: {
    quickLinks: "Links",
    bookAppointment: "Marcar Consulta",
  },
  altsImgs: {
    btnWhatsapp: "Inicar conversa no whatsapp",
    logoDiverse: "Diverse Care Now",
    slide1: "Slide 1",
    slide2: "Slide 2",
  },
  carousel: {
    previous: "Anterior",
    next: "Próximo",
  },
  modal: {
    title: "Marcar uma consulta",
    message: "Marcar uma consulta agora",
    close: "Fechar",
    bookNow: "Marcar agora",
  },
};
